"use client";

import { c as _c } from "react/compiler-runtime";
import dynamic from "next/dynamic";
import React, { ReactNode, useCallback } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import BottomNavigation from "../navigation/BottomNavigation";
import { useViewContext } from "../navigation/ViewContext";
import BrainMobileWaves from "../brain/mobile/BrainMobileWaves";
import { useLayout } from "../brain/my-stream/layout/LayoutContext";
import HeaderPlaceholder from "../header/HeaderPlaceholder";
import { useHeaderContext } from "@/contexts/HeaderContext";
import { useDeepLinkNavigation } from "@/hooks/useDeepLinkNavigation";
import BrainMobileMessages from "../brain/mobile/BrainMobileMessages";
import { useSelector } from "react-redux";
import { selectEditingDropId } from "@/store/editSlice";
import useDeviceInfo from "@/hooks/useDeviceInfo";
const TouchDeviceHeader = dynamic(() => import("../header/AppHeader"), {
  ssr: false,
  loading: () => <HeaderPlaceholder />
});
interface Props {
  readonly children: ReactNode;
}
export default function AppLayout(t0) {
  const $ = _c(28);
  const {
    children
  } = t0;
  useDeepLinkNavigation();
  const {
    registerRef
  } = useLayout();
  const {
    setHeaderRef
  } = useHeaderContext();
  const {
    activeView,
    homeActiveTab
  } = useViewContext();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams?.get("drop");
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isSingleDropOpen = t1 !== null;
  let t2;
  if ($[2] !== searchParams) {
    t2 = searchParams?.get("wave");
    $[2] = searchParams;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const waveParam = t2;
  let t3;
  if ($[4] !== searchParams) {
    t3 = searchParams?.get("view");
    $[4] = searchParams;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const viewParam = t3;
  const hasWaveParam = Boolean(waveParam);
  const isViewingWavesOrMessages = viewParam === "waves" || viewParam === "messages";
  const isStreamRoute = pathname === "/waves" || pathname === "/messages" || pathname === "/notifications" || pathname === "/" && (hasWaveParam || isViewingWavesOrMessages);
  const isHomeFeedView = pathname === "/" && homeActiveTab === "feed";
  const editingDropId = useSelector(selectEditingDropId);
  const {
    isApp
  } = useDeviceInfo();
  const isEditingOnMobile = isApp && editingDropId !== null;
  let t4;
  if ($[6] !== registerRef || $[7] !== setHeaderRef) {
    t4 = node => {
      registerRef("header", node);
      setHeaderRef(node);
    };
    $[6] = registerRef;
    $[7] = setHeaderRef;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const headerWrapperRef = t4;
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <TouchDeviceHeader />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== headerWrapperRef) {
    t6 = <div ref={headerWrapperRef}>{t5}</div>;
    $[10] = headerWrapperRef;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== activeView || $[13] !== children || $[14] !== isHomeFeedView) {
    t7 = activeView === "messages" ? <BrainMobileMessages /> : activeView === "waves" ? <BrainMobileWaves /> : <main className={isHomeFeedView ? "tw-h-full tw-overflow-hidden" : undefined}>{children}</main>;
    $[12] = activeView;
    $[13] = children;
    $[14] = isHomeFeedView;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== isHomeFeedView || $[17] !== isSingleDropOpen || $[18] !== isStreamRoute) {
    t8 = !isSingleDropOpen && !isStreamRoute && !isHomeFeedView && <div className="tw-h-16 tw-w-full" />;
    $[16] = isHomeFeedView;
    $[17] = isSingleDropOpen;
    $[18] = isStreamRoute;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== isEditingOnMobile || $[21] !== isSingleDropOpen) {
    t9 = !isSingleDropOpen && !isEditingOnMobile && <BottomNavigation />;
    $[20] = isEditingOnMobile;
    $[21] = isSingleDropOpen;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t6 || $[24] !== t7 || $[25] !== t8 || $[26] !== t9) {
    t10 = <div className="tw-pb-[env(safe-area-inset-bottom,0px)]">{t6}{t7}{t8}{t9}</div>;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
}